import { __makeTemplateObject } from "tslib";
import * as React from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { mq } from '@metro-ui/utils/es6/mediaQuery';
export var CountryFlagImage = styled(function (_a) {
    var variant = _a.variant, className = _a.className;
    return React.createElement(variant, {
        className: className,
    });
})(function () { return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    border-radius: 50%;\n    width: 100%;\n    height: auto;\n    vertical-align: text-bottom;\n\n    ", "\n  "], ["\n    border-radius: 50%;\n    width: 100%;\n    height: auto;\n    vertical-align: text-bottom;\n\n    ",
    "\n  "])), mq('s') && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        transform: none;\n      "], ["\n        transform: none;\n      "])))); });
var templateObject_1, templateObject_2;
//# sourceMappingURL=CountryFlagImage.js.map